const doc = [({"en":({"js":({"preview":({"preview":"Preview", "open":"Open"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;